import { actionCreatorFactory } from "typescript-fsa";

const factory = actionCreatorFactory("MODULF");
export const deleteProcessDocument = factory<DeleteProcessDocumentData>("DELETE_PROCESS_DOCUMENT");
export interface DeleteProcessDocumentData {
	readonly instanceId: string;
	readonly modalActivityId: string;
	readonly overviewActivityId: string;
}

export const changeZugehoerigkeit = factory<changeZugehoerigkeitData>("SET_ZUGEHOERIGKEIT");
export interface changeZugehoerigkeitData {
	readonly instanceId: string;
	readonly activityId: string;
	readonly overviewActivityId: string;
	readonly zugehoerigkeit?: string;
}
